import { render, staticRenderFns } from "./CheckPlate.vue?vue&type=template&id=4e82d502&"
import script from "./CheckPlate.vue?vue&type=script&lang=ts&"
export * from "./CheckPlate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports